import { render, staticRenderFns } from "./RmaConfirmation.vue?vue&type=template&id=a94d513e&scoped=true"
import script from "./RmaConfirmation.vue?vue&type=script&lang=ts"
export * from "./RmaConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./RmaConfirmation.vue?vue&type=style&index=0&id=a94d513e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.1__lodash@4.18.1__uh3ogwxii3moa5gavesbrodcau/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94d513e",
  null
  
)

export default component.exports